"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importStar(require("react"));
var LayoutCommandButton_1 = require("./LayoutCommandButton");
var LayoutCommandOverflowButton_1 = require("./LayoutCommandOverflowButton");
var LayoutContentHeaderTitle_1 = require("./LayoutContentHeaderTitle");
exports.LayoutContentHeader = function (props) {
    var commandButtons = props.commandButtons, menuEntry = props.menuEntry, commandButtonComponent = props.commandButtonComponent, headerTitleComponent = props.headerTitleComponent;
    var actionDivRef = react_2.useRef(null);
    var width = react_2.useState(0)[0];
    var _a = react_2.useState({
        buttons: [],
        overflowButtons: [],
    }), commandActions = _a[0], setCommandActions = _a[1];
    react_2.useEffect(function () {
        var visibleButtons = Math.floor(width / 150);
        if (commandButtons && commandButtons.length > 0) {
            setCommandActions({
                buttons: commandButtons.slice(0, visibleButtons),
                overflowButtons: commandButtons
                    .slice(visibleButtons, commandButtons.length)
                    .map(function (item) {
                    if (item.menuProps) {
                        return __assign(__assign({}, item), { subMenuProps: {
                                items: __spreadArrays(item.menuProps.items),
                            }, iconProps: {
                                iconName: item.icon,
                            } });
                    }
                    return __assign(__assign({}, item), { iconProps: {
                            iconName: item.icon,
                        } });
                }),
            });
        }
        else {
            setCommandActions({
                buttons: [],
                overflowButtons: [],
            });
        }
    }, [width, commandButtons]);
    var CommandButtonComponent = commandButtonComponent !== null && commandButtonComponent !== void 0 ? commandButtonComponent : LayoutCommandButton_1.LayoutCommandButton;
    var HeaderTitleComponent = headerTitleComponent !== null && headerTitleComponent !== void 0 ? headerTitleComponent : LayoutContentHeaderTitle_1.LayoutContentHeaderTitle;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "eta-layout-content-header" },
            menuEntry && react_2.default.createElement(HeaderTitleComponent, { menuEntry: menuEntry }),
            react_2.default.createElement("div", { className: "layout-content-header-action", ref: actionDivRef },
                react_2.default.createElement(react_1.OverflowSet, { items: commandActions.buttons, overflowItems: commandActions.overflowButtons, onRenderItem: function (propsItem) { return (
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    react_2.default.createElement(CommandButtonComponent, __assign({}, propsItem))); }, onRenderOverflowButton: LayoutCommandOverflowButton_1.renderOverflowButton })))));
};
//# sourceMappingURL=LayoutContentHeader.js.map